<!--
  Componente de modal genérico para exibição de título e mensagem, com suporte a redirecionamento.
-->

<template>
  <div
    id="myModal"
    ref="myModal"
    class="modal"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
        </div>
        <div class="modal-body">
          <p>{{ message }}</p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn botao-padrao"
            data-bs-dismiss="modal"
            @click="handleOkClick"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from 'bootstrap';

export default {
  name: "ModalMessage",

  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    redirectTo: {
      type: String,
      default: null
    }
  },

  emits: [
    'ok'
  ],

  mounted() {
    this.modalInstance = new bootstrap.Modal(this.$refs.myModal, {});
  },

  methods: {
    openModal() {
      this.modalInstance.show();
    },
    
    handleOkClick() {
      this.modalInstance.hide();
      if (this.redirectTo) {
        this.$router.push(this.redirectTo);
      }
      this.$emit('ok');
    }
  }
}
</script>